import { render, staticRenderFns } from "./ApiTree.vue?vue&type=template&id=3ade97ad&scoped=true"
import script from "./ApiTree.vue?vue&type=script&lang=js"
export * from "./ApiTree.vue?vue&type=script&lang=js"
import style0 from "./ApiTree.vue?vue&type=style&index=0&id=3ade97ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade97ad",
  null
  
)

export default component.exports